import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=8bb7eb66&lang=html&"
import script from "./ProductPrice.vue?vue&type=script&lang=js&"
export * from "./ProductPrice.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductPrice.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "77264466"
  
)

export default component.exports